export default {
  'pt': {
    yourVersion: 'Sua versão: {version}',
    latestVersion: 'Última versão: {version}',
    username: 'Usuário',
    password: 'Senha',
    repeatPassword: 'Repetir senha',
    email: 'E-mail',
    clickHere: 'clique aqui',
    createPassword: 'Criar senha',
    createPasswordDescription: 'Informe a senha desejada',
    forgotPassword: 'Esqueci minha senha',
    forgotPasswordUrl: 'esqueci-minha-senha',
    forgotPasswordDescription: 'Informe seu e-mail',
    login: 'Entrar',
    loginOption: 'ou',
    loginWith:'Entrar com',
    wait: 'Aguarde...',
    youWillBeRedirected: 'Você será redirecionado...',
    authorizationCodeIsMandatory: 'O código de autorização é obrigatório',
    createNewPassword: 'Recuperar senha',
    createNewPasswordSuccess: 'Nova senha criada!',
    createNewPasswordSupportContact: 'contato com o suporte',
    createNewPasswordFail: 'Um erro ocorreu ao criar a senha. Entre em {link} ou tente mais tarde.',
    createNewPasswordReturnMessage: 'Sua nova senha está pronta para uso',
    backToMainScreen: 'Voltar para a tela inicial',
    returnToMainScreen: 'Acessar o Involves Stage',
    requiredField: 'Este campo é obrigatório',
    emailInvalid: 'O formato de e-mail está inválido',
    emailNotFound: 'Endereço não encontrado',
    emailRecoverSuccess: 'Instruções enviadas para o seu e-mail.',
    recoverPasswordNewRequest: 'Faça uma nova solicitação',
    recoverTokenExpired: 'O tempo para recuperar a senha expirou. {link}.',
    differentPassword: 'As senhas devem ser idênticas',
    resetedPasswordUrl: 'senha-resetada-com-sucesso',
    termPasswordReuseNotEnabled: 'Sua nova senha deve ser diferente das anteriores',
    colabErrorSavePasswordEntropy: 'Escolha uma senha mais segura',
    weakPassword: 'Escolha uma senha mais segura',
    'login.wrongcredentials': 'Usuário ou senha não encontrados.',
    'login.passwordexpired': 'Sua senha expirou. Se você possui um e-mail cadastrado, clique em "Esqueci minha senha" para redefini-la. Caso contrário, entre em contato com o suporte.',
    'login.passwordblocked': 'Sua senha foi bloqueada. Se você possui um e-mail cadastrado, clique em "Esqueci minha senha" para redefini-la. Caso contrário, entre em contato com o suporte.'
  },
  'es': {
    yourVersion: 'Tu versión: {version}',
    latestVersion: 'Última versión: {version}',
    username: 'Usuario',
    password: 'Contraseña',
    repeatPassword: 'Repetir contraseña',
    email: 'E-mail',
    clickHere: 'haga clic aquí',
    createPassword: 'Crear contraseña',
    createPasswordDescription: 'Digite la nueva contraseña',
    forgotPassword: 'Olvidé mi contraseña',
    forgotPasswordUrl: 'olvide-mi-contrasena',
    forgotPasswordDescription: 'Digite su e-mail',
    login: 'Entrar',
    loginOption: 'o bien',
    loginWith:'Entrar con',
    wait: 'Espere...',
    youWillBeRedirected: 'Serás redirigido',
    authorizationCodeIsMandatory: 'El código de autorización es obligatorio',
    createNewPassword: 'Restablecer contraseña',
    createNewPasswordSuccess: '¡La contraseña ha sido reestablecida!',
    createNewPasswordSupportContact: 'contacto con Soporte',
    createNewPasswordFail: 'Hubo un error al crear la contraseña. Póngase en {link} o vuelva a intentarlo más tarde.',
    createNewPasswordReturnMessage: 'Ahora podrá usar la nueva contraseña',
    backToMainScreen: 'Volver a la pantalla inicial',
    returnToMainScreen: 'Ir a Involves Stage',
    requiredField: 'Este campo es obligatorio',
    emailInvalid: 'El formato de e-mail no es válido, ej: nombre@empresa.com',
    emailNotFound: 'E-mail no encontrado',
    emailRecoverSuccess: 'Usted recibirá las instrucciones en su e-mail, revise su bandeja de entrada.',
    recoverPasswordNewRequest: 'Hacer una nueva solicitud',
    recoverTokenExpired: 'El tiempo para recuperar la contraseña se ha agotado. {link}.',
    differentPassword: 'Las contraseñas no coinciden',
    resetedPasswordUrl: 'contrasena-reiniciada-con-exito',
    termPasswordReuseNotEnabled: 'Su nueva contraseña debe ser diferente a las que ha usado en el pasado',
    colabErrorSavePasswordEntropy: 'Cree una contraseña más segura',
    weakPassword: 'La contraseña es muy débil, cree una más segura',
    'login.wrongcredentials': 'Por favor, verifique si el usuario o la contraseña fueron escritos correctamente.',
    'login.passwordexpired': 'Su contraseña ha expirado. Si tiene un e-mail registrado, haga clic en "Olvidé mi contraseña" para restablecerla. De lo contrario, comuníquese con el soporte.',
    'login.passwordblocked': 'Su contraseña ha sido bloqueada. Si tiene un e-mail registrado, haga clic en "Olvidé mi contraseña" para restablecerla. De lo contrario, comuníquese con el soporte.'
  },
  'en': {
    yourVersion: 'Your version: {version}',
    latestVersion: 'Latest version: {version}',
    username: 'User',
    password: 'Password',
    repeatPassword: 'Please, repeat your password',
    email: 'E-mail',
    clickHere: 'click here',
    createPassword: 'Create a new password',
    createPasswordDescription: 'Set your new password',
    forgotPassword: 'I forgot my password',
    forgotPasswordUrl: 'forgot-my-password',
    forgotPasswordDescription: 'Please, enter your e-mail address',
    login: 'Login',
    loginOption: 'Or',
    loginWith:'Login with',
    wait: 'Wait...',
    youWillBeRedirected: 'You will be redirected',
    authorizationCodeIsMandatory: 'Authorization code is mandatory',
    createNewPassword: 'Recover your password',
    createNewPasswordSuccess: 'Your new password has been set',
    createNewPasswordSupportContact: 'contact our Support Team',
    createNewPasswordFail: 'It was not possible to create a new password. Please, try again in a few minutes or {link}.',
    createNewPasswordReturnMessage: 'Your new password is ready for use',
    backToMainScreen: 'Return to the main screen',
    returnToMainScreen: 'Go to Involves Stage',
    requiredField: 'This is a required field',
    emailInvalid: 'This e-mail format is not a valid one, please try again.',
    emailNotFound: 'Your e-mail could not be found, please check if it was typed correctly',
    emailRecoverSuccess: 'We\'ve sent some Instructions to your e-mail.',
    recoverPasswordNewRequest: 'Create a new request.',
    recoverTokenExpired: 'The password reset link has expired. {link}.',
    differentPassword: 'The entered Passwords don\'t match',
    resetedPasswordUrl: 'password-reset-successfuly',
    termPasswordReuseNotEnabled: 'Your password must be different from previously used passwords',
    colabErrorSavePasswordEntropy: 'Create a stronger password',
    weakPassword: 'This password is not safe, please provide a stronger one',
    'login.wrongcredentials': 'Please, check if the username or password were typed correctly.',
    'login.passwordexpired': 'Your password has expired. If you have an e-mail registered, click on "I forgot my password" to reset it. Otherwise, please contact support.',
    'login.passwordblocked': 'Your password has been blocked. If you have an e-mail registered, click on "I forgot my password" to reset it. Otherwise, please contact support.'
  },
  'fr': {
    yourVersion: 'Votre version : {version}',
    latestVersion: 'Dernière version : {version}',
    username: 'Nom d’utilisateur',
    password: 'Mot de passe',
    repeatPassword: 'S\'il vous plaît, répétez votre mot de passe',
    email: 'E-mail',
    clickHere: 'Cliquez ici',
    createPassword: 'Créez un nouveau mot de passe',
    createPasswordDescription: 'Définissez votre nouveau mot de passe',
    forgotPassword: 'J\'ai oublié mon mot de passe',
    forgotPasswordUrl: 'oublie-mot-de-passe',
    forgotPasswordDescription: 'S\'il vous plaît, entrez votre adresse e-mail',
    login: 'Se connecter',
    loginOption: 'Ou',
    loginWith:'Se connecter avec',
    wait: 'Attendez ...',
    youWillBeRedirected: 'Vous serez redirigé ...',
    authorizationCodeIsMandatory: 'Le code d\'autorisation est obligatoire',
    createNewPassword: 'Récupérez votre mot de passe',
    createNewPasswordSuccess: 'Votre nouveau mot de passe a été défini',
    createNewPasswordSupportContact: 'contactez notre équipe de support',
    createNewPasswordFail: 'Impossible de créer un nouveau mot de passe. Réessayer dans quelques minutes ou {link}.',
    createNewPasswordReturnMessage: 'Votre nouveau mot de passe est prêt à être utilisé',
    backToMainScreen: 'Retour à l\'écran principal',
    returnToMainScreen: 'Aller à Involves Stage',
    requiredField: 'Ceci est un champ obligatoire',
    emailInvalid: 'Ce format d\'e-mail n\'est pas valide, réessayer.',
    emailNotFound: 'Impossible de trouver votre e-mail, vérifier s\'il a été saisi correctement',
    emailRecoverSuccess: 'Nous avons envoyé des instructions à votre e-mail.',
    recoverPasswordNewRequest: 'Créer une nouvelle demande.',
    recoverTokenExpired: 'Le lien de réinitialisation du mot de passe a expiré. {link}.',
    differentPassword: 'Les mots de passe ne correspondent pas',
    resetedPasswordUrl: 'mot-de-passe-reinitialiser-avec-succes',
    termPasswordReuseNotEnabled: 'Votre mot de passe doit être différent des mots de passe précédemment utilisés',
    colabErrorSavePasswordEntropy: 'Créer un mot de passe plus fort',
    weakPassword: 'Ce mot de passe n\'est pas sûr, veuillez en fournir un plus fort',
    'login.wrongcredentials': 'Veuillez vérifier si le nom d’utilisateur ou le mot de passe a été saisi correctement.',
    'login.passwordexpired': 'Votre mot de passe a expiré. Si vous avez un e-mail enregistré, cliquez sur "J\'ai oublié mon mot de passe" pour le réinitialiser. Sinon, veuillez contacter le support.',
    'login.passwordblocked': 'Votre mot de passe a été bloqué. Si vous avez un e-mail enregistré, cliquez sur "J\'ai oublié mon mot de passe" pour le réinitialiser. Sinon, veuillez contacter le support.'
  },
}